import React from "react";
import { Button } from "react-bootstrap";
import HeaderLayout from "./HeaderLayout";
import CardsLayout from "./cardsLayout";
import { Link } from "react-router-dom";
import {
  forecastReplenishByVendorAndDC,
  updateForecastReplenishByVendorAndDc
} from "../../../actions";
import Spinner from "../../common/Spinner";
import Sanckbar from "../../common/Sanckbar";
import StatusModal from "../../common/StatusModal";

class ManageVendorForecastByDC extends React.Component {
  state = {
    notificationMsg: "",
    isSaveEnabled: false
  };
  constructor() {
    super();
    this.cardsData = [];
    this.allData = {};
    this.oldInfo = [];
    this.newInfo = {};
    this.validatedInfo = {};
  }
  componentDidMount() {
    document.addEventListener("keydown", this.pressEnter);
  }
  setErrorMessage = msg => {
    this.setNotification(msg, "red", "cancel");
  };
  setWarningMessage = msg => {
    this.setNotification(msg, "orange", "warning", 3000);
  };
  setSuccessMessage = msg => {
    this.setNotification(msg, "#47fb47", "check", 3000);
  };
  setTransitioMessage = msg => {
    this.setNotification(msg, null, null);
  };
  setNotification = (text, color, icon, timeout) => {
    clearTimeout(this.snackbarTimer);

    if (text) {
      this.setState({ notificationMsg: { text, color, icon } });
      this.setState({ isNotificationOpened: true });
    } else {
      this.setState({ isNotificationOpened: false });
    }
    if (timeout) {
      this.snackbarTimer = setTimeout(() => {
        this.setState({ isNotificationOpened: false });
      }, timeout);
    }
  };

  formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }
  lookup = msg => {
    this.setTransitioMessage(<Spinner msg="Loading..." />);
    if (this.state.lookup && this.state.lookup.item && this.state.lookup.wse) {
      var item = this.state.lookup.item;
      forecastReplenishByVendorAndDC(item, this.state.lookup.wse).then(res => {
        msg ? this.setSuccessMessage(msg) : this.setTransitioMessage("");
        const data = res.data.data;
        this.setState({ data });
        if (res.data.success) {
         // const whsesForItem = res.data.data.whsesForItem;
          //delete data.whsesForItem;
          this.setState({
            header: [
              {
                label: "Vendor",
                value: data.vendor,
                name: "vendor"
              },
              {
                label: "Vendor Name",
                value: data.vname,
                name: "vname"
              },
              {
                label: "Warehouses",
                //obj: whsesForItem,
                name: "wse"
              }
            ],
            cards: [
              //cards
              {
                card1: [
                  {
                    label: "Order Supply Info",
                    name: "tag1"
                  },
                  {
                    label: "Go Strat",
                    value: data.target,
                    name: "target"
                  },
                  {
                    label: "Min Gate",
                    value: data.minDays,
                    name: "minDays"
                  },
                  {
                    label: "CGo Strat",
                    value: data.actual,
                    name: "actual"
                  },
                  {
                    label: "Allocation Control Flags",
                    name: "tag2"
                  },
                  {
                    label: "EOQ Days",
                    value: data.eoqDays,
                    name: "eoqDays"
                  },
                  {
                    label: "Usage Control",
                    value: data.usageCl,
                    name: "usageCl"
                  },
                  {
                    label: "EOQ Logic",
                    value: data.eoqFlag,
                    name: "eoqFlag"
                  },
                  {
                    label: "Service Used",
                    value: data.srvUsed,
                    name: "srvUsed"
                  },
                  {
                    label: "Service Type",
                    value: data.srvType,
                    name: "srvType"
                  },
                  {
                    label: "Solve Search",
                    value: data.solveSe,
                    name: "solveSe"
                  },
                  {
                    label: "Pallet Rounding",
                    value: data.plltRou,
                    name: "plltRou"
                  },
                  {
                    label: "Multi-Truck",
                    value: data.mTruck,
                    name: "mTruck"
                  },
                  {
                    label: "Truck Load Flag",
                    value: data.tLoadFg,
                    name: "tLoadFg"
                  },
                  {
                    label: "Order Force Flag",
                    value: data.oForcFg,
                    name: "oForcFg"
                  },
                  {
                    label: "Auto Order Flag",
                    value: data.autoFlg,
                    name: "autoFlg"
                  }
                ]
              },
              {
                "Order Constraints": [
                  {
                    label: "",
                    span: "Type",
                    name: "tag3"
                  },
                  {
                    label: "",
                    span: "Minimum Amt",
                    name: "tag4"
                  },
                  {
                    label: "",
                    span: "% Total",
                    name: "tag5"
                  },
                  {
                    label: "",
                    span: "Maximum Amt",
                    name: "tag6"
                  },
                  {
                    label: "",
                    span: "% Total",
                    name: "tag7"
                  },
                  {
                    label: "",
                    span: "Constraint 1",
                    name: "tag8"
                  },
                  {
                    label: "",
                    value: data.type01,
                    name: "type01"
                  },
                  {
                    label: "",
                    value: data.mnAmt01,
                    name: "mnAmt01"
                  },
                  {
                    label: "",
                    value: data.nPctL01,
                    name: "nPctL01"
                  },
                  {
                    label: "",
                    value: this.formatNumber(data.mxAmt01),
                    name: "mxAmt01"
                  },
                  {
                    label: "",
                    value: data.xPctL01,
                    name: "xPctL01"
                  },
                  {
                    label: "",
                    span: "Constraint 2",
                    name: "tag9"
                  },
                  {
                    label: "",
                    value: data.type02,
                    name: "type02"
                  },
                  {
                    label: "",
                    value: data.mnAmt02,
                    name: "mnAmt02"
                  },
                  {
                    label: "",
                    value: data.nPctL02,
                    name: "nPctL02"
                  },
                  {
                    label: "",
                    value: this.formatNumber(data.mxAmt02),
                    name: "mxAmt02"
                  },
                  {
                    label: "",
                    value: data.xPctL02,
                    name: "xPctL02"
                  },
                  {
                    label: "",
                    span: "Constraint 3",
                    name: "tag10"
                  },
                  {
                    label: "",
                    value: data.type03,
                    name: "type03"
                  },
                  {
                    label: "",
                    value: data.mnAmt03,
                    name: "mnAmt03"
                  },
                  {
                    label: "",
                    value: data.nPctL03,
                    name: "nPctL03"
                  },
                  {
                    label: "",
                    value: this.formatNumber(data.mxAmt03),
                    name: "mxAmt03"
                  },
                  {
                    label: "",
                    value: data.xPctL03,
                    name: "xPctL03"
                  }
                ]
              },
              {
                Outer: [
                  {
                    label: "",
                    span: "Date",
                    name: "tag11"
                  },
                  {
                    label: "",
                    span: "Items",
                    name: "tag12"
                  },
                  {
                    label: "",
                    span: "Date",
                    name: "tag13"
                  },
                  {
                    label: "",
                    span: "Items",
                    name: "tag14"
                  },

                  {
                    label: data.rODate1,
                    value: data.rODays1,
                    name: "rODate1"
                  },
                  {
                    label: data.rODate6,
                    value: data.rODays6,
                    name: "rODate6"
                  },
                  {
                    label: data.rODate2,
                    value: data.rODays2,
                    name: "rODate2"
                  },
                  {
                    label: data.rODate7,
                    value: data.rODays7,
                    name: "rODate7"
                  },
                  {
                    label: data.rODate3,
                    value: data.rODays3,
                    name: "rODate3"
                  },
                  {
                    label: data.rODate8,
                    value: data.rODays8,
                    name: "rODate8"
                  },
                  {
                    value: data.rODays4,
                    label: data.rODate4,
                    name: "rODate4"
                  },
                  {
                    value: data.rODays9,
                    label: data.rODate9,
                    name: "rODate9"
                  },
                  {
                    label: data.rODate5,
                    value: data.rODays5,
                    name: "rODate5"
                  },
                  {
                    label: data.rODate10,
                    value: data.rODays10,
                    name: "rODate10"
                  }
                ]
              }
            ]
          });
        } else {
          this.setState({
            header: [
              {
                label: "Vendor",
                value: "", // data.vendor,
                name: "vendor"
              },
              {
                label: "Vendor Name",
                value: "", // data.vname,
                name: "vname"
              },
              {
                label: "Warehouses",
                // obj: whsesForItem,
                name: "wse"
              }
            ],
            cards: [
              //cards
              {
                card1: [
                  {
                    label: "Order Supply Info",
                    name: "tag1"
                  },
                  {
                    label: "Go Strat",
                    value: "", // data.target,
                    name: "target"
                  },
                  {
                    label: "Min Gate",
                    value: "", // data.minDays,
                    name: "minDays"
                  },
                  {
                    label: "CGo Strat",
                    value: "", // data.actual,
                    name: "actual"
                  },
                  {
                    label: "Allocation Control Flags",
                    name: "tag2"
                  },
                  {
                    label: "EOQ Days",
                    value: "", // data.eoqDays,
                    name: "eoqDays"
                  },
                  {
                    label: "Usage Control",
                    value: "", // data.usageCl,
                    name: "usageCl"
                  },
                  {
                    label: "EOQ Logic",
                    value: "", // data.eoqFlag,
                    name: "eoqFlag"
                  },
                  {
                    label: "Service Used",
                    value: "", // data.srvUsed,
                    name: "srvUsed"
                  },
                  {
                    label: "Service Type",
                    value: "", // data.srvType,
                    name: "srvType"
                  },
                  {
                    label: "Solve Search",
                    value: "", // data.solveSe,
                    name: "solveSe"
                  },
                  {
                    label: "Pallet Rounding",
                    value: "", // data.plltRou,
                    name: "plltRou"
                  },
                  {
                    label: "Multi-Truck",
                    value: "", // data.mTruck,
                    name: "mTruck"
                  },
                  {
                    label: "Truck Load Flag",
                    value: "", // data.tLoadFg,
                    name: "tLoadFg"
                  },
                  {
                    label: "Order Force Flag",
                    value: "", // data.oForcFg,
                    name: "oForcFg"
                  },
                  {
                    label: "Auto Order Flag",
                    value: "", // data.autoFlg,
                    name: "autoFlg"
                  }
                ]
              },
              {
                "Order Constraints": [
                  {
                    label: "",
                    span: "Type",
                    name: "tag3"
                  },
                  {
                    label: "",
                    span: "Minimum Amt",
                    name: "tag4"
                  },
                  {
                    label: "",
                    span: "% Total",
                    name: "tag5"
                  },
                  {
                    label: "",
                    span: "Maximum Amt",
                    name: "tag6"
                  },
                  {
                    label: "",
                    span: "% Total",
                    name: "tag7"
                  },
                  {
                    label: "",
                    span: "Constraint 1",
                    name: "tag8"
                  },
                  {
                    label: "",
                    value: "", // data.type01,
                    name: "type01"
                  },
                  {
                    label: "",
                    value: "", // data.mnAmt01,
                    name: "mnAmt01"
                  },
                  {
                    label: "",
                    value: "", // data.nPctL01,
                    name: "nPctL01"
                  },
                  {
                    label: "",
                    value: "", // data.mxAmt01,
                    name: "mxAmt01"
                  },
                  {
                    label: "",
                    value: "", // data.xPctL01,
                    name: "xPctL01"
                  },
                  {
                    label: "",
                    span: "Constraint 2",
                    name: "tag9"
                  },
                  {
                    label: "",
                    value: "", // data.type02,
                    name: "type02"
                  },
                  {
                    label: "",
                    value: "", // data.mnAmt02,
                    name: "mnAmt02"
                  },
                  {
                    label: "",
                    value: "", // data.nPctL02,
                    name: "nPctL02"
                  },
                  {
                    label: "",
                    value: "", // data.mxAmt02,
                    name: "mxAmt02"
                  },
                  {
                    label: "",
                    value: "", // data.xPctL02,
                    name: "xPctL02"
                  },
                  {
                    label: "",
                    span: "Constraint 3",
                    name: "tag10"
                  },
                  {
                    label: "",
                    value: "", // data.type03,
                    name: "type03"
                  },
                  {
                    label: "",
                    value: "", // data.mnAmt03,
                    name: "mnAmt03"
                  },
                  {
                    label: "",
                    value: "", // data.nPctL03,
                    name: "nPctL03"
                  },
                  {
                    label: "",
                    value: "", // data.mxAmt03,
                    name: "mxAmt03"
                  },
                  {
                    label: "",
                    value: "", // data.xPctL03,
                    name: "xPctL03"
                  }
                ]
              },
              {
                Outer: [
                  {
                    label: "",
                    span: "Date",
                    name: "tag11"
                  },
                  {
                    label: "",
                    span: "Items",
                    name: "tag12"
                  },
                  {
                    label: "",
                    span: "Date",
                    name: "tag13"
                  },
                  {
                    label: "",
                    span: "Items",
                    name: "tag14"
                  },

                  {
                    label: "", // data.rODate1,
                    value: "", // data.rODays1,
                    name: "rODate1"
                  },
                  {
                    label: "", // data.rODate6,
                    value: "", // data.rODays6,
                    name: "rODate6"
                  },
                  {
                    label: "", // data.rODate2,
                    value: "", // data.rODays2,
                    name: "rODate2"
                  },
                  {
                    label: "", // data.rODate7,
                    value: "", // data.rODays7,
                    name: "rODate7"
                  },
                  {
                    label: "", // data.rODate3,
                    value: "", // data.rODays3,
                    name: "rODate3"
                  },
                  {
                    label: "", // data.rODate8,
                    value: "", // data.rODays8,
                    name: "rODate8"
                  },
                  {
                    value: "", // data.rODays4,
                    label: "", // data.rODate4,
                    name: "rODate4"
                  },
                  {
                    value: "", // data.rODays9,
                    label: "", // data.rODate9,
                    name: "rODate9"
                  },
                  {
                    label: "", // data.rODate5,
                    value: "", // data.rODays5,
                    name: "rODate5"
                  },
                  {
                    label: "", // data.rODate10,
                    value: "", // data.rODays10,
                    name: "rODate10"
                  }
                ]
              }
            ]
          });
        }
      }).catch(err => {
        const code = String(err).split('code')[1];
        if(code == 401) {
          this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
        } else {
            this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
            setTimeout(() => {
              this.setErrorMessage();
            }, 3000);
        }
      });
    } else {
      this.setErrorMessage("Please type vendor and select a warehouse");
      setTimeout(() => {
        this.setErrorMessage();
      }, 2000);
    }
  };
  getHeaderInfo = value => {
    this.setState({
      lookup: {
        item: value.header.vendor,
        wse: value.header.wse ? value.header.wse[0] : 0,
        whses: value.header.wse
      }
    });

    this.handleInformation(value);
  };
  getCardsInfo = value => {
    this.handleInformation(value);
  };
  handleInformation = value => {
    Object.keys(value[Object.keys(value)]).map(
      val => (this.allData[val] = value[Object.keys(value)][val])
    );
    if (this.state.data) {
      for (let i = 0; i < Object.keys(this.state.data).length; i++) {
        this.newInfo[Object.keys(this.state.data)[i]] = this.allData[
          Object.keys(this.state.data)[i]
        ]
          ? this.allData[Object.keys(this.state.data)[i]]
          : this.state.data[Object.keys(this.state.data)[i]];
      }
      this.checkHotChanges();
    }
  };
  checkHotChanges = () => {
    this.setState({
      isSaveEnabled:
        JSON.stringify(this.state.data).replace(/"/g, "") !==
        JSON.stringify(this.newInfo).replace(/"/g, "")
    });
  };
  pressEnter = e => {
    if (e.key === "Enter") {
      this.lookup();
    }
  };

  save = () => {
    for (let i = 0; i < Object.keys(this.validatedInfo).length; i++) {
      this.newInfo[Object.keys(this.validatedInfo)[i]] = this.validatedInfo[
        Object.keys(this.validatedInfo)[i]
      ];
    }
    const formattedWhses = this.state.lookup.whses.map(wse => {
      return wse.toString();
    });
    var uId = sessionStorage.getItem("uId");
    var obj = {
      audit: {
        userId: uId
      },
      whses: formattedWhses,
      data: this.newInfo
    };
    this.setTransitioMessage(<Spinner msg="Saving..." />);
    updateForecastReplenishByVendorAndDc(obj).then(res => {
      if (res.data.success) {
        this.setState({ data: "" });
        this.newInfo = {};
        this.lookup("Item was successfully updated");
        this.setSuccessMessage("Item was successfully updated");
        this.setState({ isSaveEnabled: false });
        this.lookup();
      } else {
        this.setErrorMessage(res.data.messages[0].text);
      }
    }).catch(err => {
      const code = String(err).split('code')[1];
      if(code == 401) {
        this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
        setTimeout(() => {
          this.setErrorMessage();
        }, 3000);
      } else {
          this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
      }
    });
  };

  numberToZeroPadded = (num, z) => {
    var no = parseInt(num, 10);
    num = no.toString();
    var zeroNo = z - num.length;
    var zeros = "";
    for (let i = 0; i < zeroNo; i++) {
      zeros = "0" + zeros;
    }
    return zeros + no;
  };
  checkOrderConstraints = (id, value) => {
    const data = this.newInfo ? this.newInfo : this.state.data;
    var updatedState = this.state.cards;
    if (id !== "type02") {
      value = parseInt(value, 10);
    }
    if (data) {
      switch (id) {
        case "target":
          const minDays = this.validatedInfo.minDays
            ? this.validatedInfo.minDays
            : parseInt(data.minDays);

          if (value <= minDays) {
            this.setErrorMessage(`Go Strat must be bigger than Min Gate`);

            this.validatedInfo.target = minDays + 1;
            updatedState[0].card1[1].injectedValue = [
              this.validatedInfo.target,
              Math.random()
            ];
          } else {
            this.validatedInfo.target = value;
            this.setErrorMessage();
          }
          break; // bigger than minDays

        case "minDays":
          const target = this.validatedInfo.target
            ? this.validatedInfo.target
            : parseInt(data.target);

          if (value >= target) {
            this.setErrorMessage(`Go Strat  must be bigger than Min Gate`);

            this.validatedInfo[id] = target - 1;
            updatedState[0].card1[2].injectedValue = [
              this.validatedInfo[id],
              Math.random()
            ];
          } else {
            this.validatedInfo[id] = value;
            this.setErrorMessage();
          }
          break; // smaller than target
        case "mnAmt01":
          const mxAmt01 = this.validatedInfo.mxAmt01
            ? this.validatedInfo.mxAmt01
            : parseInt(data.mxAmt01);

          if (value >= mxAmt01) {
            this.setErrorMessage(
              `Maximum Amount must be bigger than Minimum Amount`
            );

            this.validatedInfo[id] = mxAmt01 - 1;
            updatedState[1]["Order Constraints"][7].injectedValue = [
              this.validatedInfo[id],
              Math.random()
            ];
          } else {
            this.validatedInfo[id] = value;
            this.setErrorMessage();
          }
          break; // smaller than mxAmt01.
        case "mxAmt01":
          const mnAmt01 = this.validatedInfo.mnAmt01
            ? this.validatedInfo.mnAmt01
            : parseInt(data.mnAmt01);

          if (value <= mnAmt01) {
            this.setErrorMessage(
              `Maximum Amount must be bigger than Minimum Amount`
            );

            this.validatedInfo[id] = mnAmt01 + 1;
            updatedState[1]["Order Constraints"][9].injectedValue = [
              this.validatedInfo[id],
              Math.random()
            ];
          } else {
            this.validatedInfo[id] = value;
            this.setErrorMessage();
          }
          break; // bigger than mnAmt01.
        case "type02":
          const type01 = this.validatedInfo.type01
            ? this.validatedInfo.type01
            : data.type01;
          if (value == type01) {
            this.setErrorMessage(
              `Constraint Type 02 must be different from Constratint Type 01`
            );

            this.validatedInfo[id] = "X";
            updatedState[1]["Order Constraints"][12].injectedValue = [
              this.validatedInfo[id],
              Math.random()
            ];
          } else {
            this.validatedInfo[id] = value;
            this.setErrorMessage();
          }
          break; // different than type01
        case "mnAmt02":
          const type02 = this.validatedInfo.type02
            ? this.validatedInfo.type02
            : data.type02;
          const mxAmt02 = this.validatedInfo.mxAmt02
            ? this.validatedInfo.mxAmt02
            : parseInt(data.mxAmt02);

          if (value >= mxAmt02) {
            this.setErrorMessage(
              `Maximum Amount must be bigger than Minimum Amount`
            );

            this.validatedInfo[id] = mxAmt02 - 1;
            updatedState[1]["Order Constraints"][13].injectedValue = [
              this.validatedInfo[id],
              Math.random()
            ];
          } else {
            this.validatedInfo[id] = value;
            this.setErrorMessage();
          }

          if (value === 0 && type02 !== " ") {
            updatedState[1]["Order Constraints"][13].injectedValue = [
              1,
              Math.random()
            ];

            this.setErrorMessage(
              `${id} can be 0 only if Constraint Type is empty`
            );
          }

          break; // Integer can be 0 only if type02 is empty and smaller than mxAmt02
        case "nPctL02":
          if (value === 0 && type02 !== " ") {
            updatedState[1]["Order Constraints"][14].injectedValue = 1;
            this.setErrorMessage(
              `${id} can be 0 only if Constraint Type is empty`
            );
          }
          break; // Integer can be 0 only if type02 is empty
        case "xPctL02":
          if (value === 0 && type02 !== " ") {
            updatedState[1]["Order Constraints"][16].injectedValue = 1;
            this.setErrorMessage(
              `${id} can be 0 only if Constraint Type is empty`
            );
          }
          break; // Integer can be 0 only if type02 is empty
        case "mxAmt02":
          // const type02 = this.validatedInfo.type02
          //   ? this.validatedInfo.type02
          //   : data.type02;
          const mnAmt02 = this.validatedInfo.mnAmt02
            ? this.validatedInfo.mnAmt02
            : parseInt(data.mnAmt02);

          if (value <= mnAmt02) {
            this.setErrorMessage(
              `Maximum Amount must be bigger than Minimum Amount`
            );

            this.validatedInfo[id] = mnAmt02 + 1;
            updatedState[1]["Order Constraints"][15].injectedValue = [
              this.validatedInfo[id],
              Math.random()
            ];
          } else {
            this.validatedInfo[id] = value;
            this.setErrorMessage();
          }

          if (value === 0 && type02 !== " ") {
            updatedState[1]["Order Constraints"][15].injectedValue = [
              1,
              Math.random()
            ];

            this.setErrorMessage(
              `${id} can be 0 only if Constraint Type is empty`
            );
          }

          break; // Integer can be 0 only if type02 is empty and bigger than mnAmt02
        case "type03":
          // const type02 = this.validatedInfo.type02
          //   ? this.validatedInfo.type02
          //   : data.type02;
          // if (value == type02) {
          //   this.setErrorMessage(
          //     `Constraint Type 02 must be different from Constratint Type 01`
          //   );

          //   this.validatedInfo[id] = "X";
          //   updatedState[1]["Order Constraints"][18].injectedValue = [
          //     this.validatedInfo[id],
          //     Math.random()
          //   ];
          // } else {
          //   this.validatedInfo[id] = value;
          //   this.setErrorMessage();
          // }
          break; // different than type02
        case "mnAmt03":
          // const type03 = this.validatedInfo.type03
          //   ? this.validatedInfo.type03
          //   : data.type03;
          // const mnAmt03 = this.validatedInfo.mnAmt03
          //   ? this.validatedInfo.mnAmt03
          //   : parseInt(data.mnAmt03);

          // if (value >= mnAmt03) {
          //   this.setErrorMessage(
          //     `Maximum Amount must be bigger than Minimum Amount`
          //   );

          //   this.validatedInfo[id] = mnAmt03 - 1;
          //   updatedState[1]["Order Constraints"][19].injectedValue = [
          //     this.validatedInfo[id],
          //     Math.random()
          //   ];
          // } else {
          //   this.validatedInfo[id] = value;
          //   this.setErrorMessage();
          // }

          // if (value === 0 && type03 !== " ") {
          //   updatedState[1]["Order Constraints"][19].injectedValue = [
          //     1,
          //     Math.random()
          //   ];

          //   this.setErrorMessage(
          //     `${id} can be 0 only if Constraint Type is empty`
          //   );
          // }

          break; // Integer can be 0 only if type03 is empty and smaller than mxAmt03
        case "nPctL03":
        //   if (value === 0 && type03 !== " ") {
        //     updatedState[1]["Order Constraints"][20].injectedValue = 1;
        //     this.setErrorMessage(
        //       `${id} can be 0 only if Constraint Type is empty`
        //     );
        //   }
        //   break; // Integer can be 0 only if type03 is empty
        // case "xPctL03":
        //   if (value === 0 && type03 !== " ") {
        //     updatedState[1]["Order Constraints"][22].injectedValue = 1;
        //     this.setErrorMessage(
        //       `${id} can be 0 only if Constraint Type is empty`
        //     );
        //   }
        //   break; // Integer can be 0 only if type03 is empty
        case "mxAmt03":
          // const type03 = this.validatedInfo.type03
          //   ? this.validatedInfo.type03
          //   : data.type03;
          // const mnAmt03 = this.validatedInfo.mnAmt03
          //   ? this.validatedInfo.mnAmt03
          //   : parseInt(data.mnAmt03);

          // if (value <= mnAmt03) {
          //   this.setErrorMessage(
          //     `Maximum Amount must be bigger than Minimum Amount`
          //   );

          //   this.validatedInfo[id] = mnAmt03 + 1;
          //   updatedState[1]["Order Constraints"][21].injectedValue = [
          //     this.validatedInfo[id],
          //     Math.random()
          //   ];
          // } else {
          //   this.validatedInfo[id] = value;
          //   this.setErrorMessage();
          // }

          // if (value === 0 && type03 !== " ") {
          //   updatedState[1]["Order Constraints"][21].injectedValue = [
          //     1,
          //     Math.random()
          //   ];

          //   this.setErrorMessage(
          //     `${id} can be 0 only if Constraint Type is empty`
          //   );
          // }

          break; // Integer can be 0 only if type03 is empty and bigger than mnAmt03
        default:
          break;
      }
      this.setState({ cards: updatedState });
      setTimeout(() => {
        this.newInfo = data;
      }, 30);
    }
  };
  componentWillUnmount() {
    document.removeEventListener("keydown", this.pressEnter);
  }

  handleOpenModal = () => {
    this.state.modalOpen
      ? this.setState({ modalOpen: false })
      : this.setState({ modalOpen: true });
  };
  closeModal = e => {
    this.setState({ modalOpen: false });
  };
  closeEP = x => {
    if (x) {
      x.target.textContent === "Save"
        ? this.save()
        : this.setSuccessMessage("Changes discarded");

      setTimeout(() => {
        this.closeEP();
      }, 1500);
    } else {
      this.props.history.push("/");
    }
  };

  checkHotChangesAndClose = () => {
    if (this.state.isSaveEnabled) {
      this.handleOpenModal();
    } else {
      this.closeEP();
    }
  };

  render() {
    return (
      <div className="container-fluid" id="example">
        <h3 className="page-title" style={{ textAlign: "center" }}>
          Vendor Forecast Replenishment By DC
        </h3>
        <HeaderLayout
          setHeaderInfo={this.getHeaderInfo}
          setErrorMessage={this.setErrorMessage}
          setSuccessMessage={this.setSuccessMessage}
          lookup={this.lookup}
          headerData={this.state.header}
        />
        <CardsLayout
          cardsData={this.state.cards}
          setCardsInfo={this.getCardsInfo}
          checkOrderConstraints={this.checkOrderConstraints}
        />

        <div className="button-bar">
          <div className="buttons">
            <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={false}
              onClick={e => this.checkHotChangesAndClose()}
            >
              Close
            </Button>

            <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={!this.state.isSaveEnabled}
              onClick={e => this.save()}
            >
              Save
            </Button>
          </div>
        </div>
        <Sanckbar
          mounted={this.state.isNotificationOpened}
          msg={{
            text: this.state.notificationMsg.text,
            color: this.state.notificationMsg.color,
            icon: this.state.notificationMsg.icon
          }}
          close={this.setNotification}
        />
        <StatusModal
          modal={this.state.modalOpen === true ? "opened" : "closed"}
          action={"choice"}
          handleOpenClose={e => this.closeModal(e)}
          buttonActions={{
            button2: this.closeEP,
            button1: this.closeEP
          }}
          msg={
            "There are unsaved changes. Please select one of the following actions."
          }
          active={true}
          buttonText2={"Save"}
          buttonText={"Discard"}
        />
      </div>
    );
  }
}
export default ManageVendorForecastByDC;
